import {createSelector} from 'reselect';
import {getListingSummary} from './listingSummary';
import {getFirstPayment, getPriceLabels, getTotals, getPriceDetails} from './priceDetails';
import {getSiteName} from './system';
import {
    isDatePickerModalOpen,
    isGuestSelectorModalOpen,
    isReportListingModalOpen,
    isRequestToBookModalOpen,
    isInquiryModalOpen
} from './modalStates';
import {getBookingType, getTakesInquiries} from './listing';
import {getTripDataDates} from './tripDates';
import {getReviewRating} from './reviews';

const getViewDetailsTotalData = createSelector(
    [getPriceDetails, getPriceLabels, getTotals, getTripDataDates],
    (priceDetails, labels, totals, dates) => ({
        edapPriceQuotePresented: priceDetails.edapPriceQuotePresented,
        labels,
        showViewDetailsLink: !!(totals || {}).totalWithoutDeposits,
        totals,
        datesAreSet: Boolean(dates && dates.arriveDateText && dates.departDateText)
    })
);

const getRightRailData = createSelector(
    [
        getBookingType,
        getListingSummary,
        getViewDetailsTotalData,
        getSiteName,
        isDatePickerModalOpen,
        isGuestSelectorModalOpen,
        isRequestToBookModalOpen,
        isInquiryModalOpen,
        isReportListingModalOpen,
        getTakesInquiries,
        getFirstPayment,
        getPriceDetails,
        getReviewRating
    ],
    (
        bookingType,
        listingSummary,
        viewDetailsTotalData,
        siteName,
        datePickerPopoverOpen,
        guestSelectorPopoverOpen,
        requestToBookModalOpen,
        inquiryModalOpen,
        reportListingModalOpen,
        takesInquiries,
        firstPaymentData,
        priceDetails,
        {reviewCount, webRatingBadges}
    ) => {
        return {
            listingSummaryData: listingSummary,
            viewDetailsTotalData,
            siteName,
            datePickerPopoverOpen,
            guestSelectorPopoverOpen,
            requestToBookModalOpen,
            inquiryModalOpen,
            reportListingModalOpen,
            showSecondaryAction: bookingType.onlineBookable && takesInquiries,
            firstPaymentData,
            currencyConversionLabel: priceDetails.currencyConversionLabel,
            reviewCount,
            webRatingBadges
        };
    }
);

export default getRightRailData;
export {getRightRailData, getViewDetailsTotalData};
